import "./index.css";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const MySelect = ({
  label = "",
  value = "",
  items = [],
  setValue = () => {},
}) => {
  return (
    <FormControl variant="outlined" className="Select">
      <Select value={value} onChange={setValue} color="primary">
        {items.map((item, index) => (
          <MenuItem key={index} value={index}>
            {item}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MySelect;
